import { jsx as _jsx } from "react/jsx-runtime";
import { useBatchUpdateFormAssetsMutation } from "@air/feature-content-collection/hooks";
import { memo, useCallback, useMemo } from "react";
import { BoardCollectionCustomFieldsSelect } from "~/components/BoardCollection/CustomFields/BoardCollectionCustomFieldsSelect";
import { boardCollectionSessionIdSelector } from "~/store/boardCollection/selectors";
import { useAirStore } from "~/utils/ReduxUtils";
export const ContentCollectionCustomFieldSingleSelect = /*#__PURE__*/ memo((param)=>{
    let { clips, customField, disabled, onSuccess, value } = param;
    const store = useAirStore();
    const { mutate: batchUpdateFormAssets, isPending } = useBatchUpdateFormAssetsMutation();
    const customFieldWithValues = useMemo(()=>({
            ...customField,
            value: value !== null && value !== void 0 ? value : null,
            values: null
        }), [
        customField,
        value
    ]);
    const onSelectionChange = useCallback((param)=>{
        let { values } = param;
        var _values_;
        const sessionId = boardCollectionSessionIdSelector(store.getState());
        if (!sessionId) {
            throw new Error("No session id");
        }
        batchUpdateFormAssets({
            assetIds: clips.map((param)=>{
                let { assetId } = param;
                return assetId;
            }),
            formSessionId: sessionId,
            update: {
                customFields: [
                    {
                        customFieldId: customField.id,
                        valueId: values === null || values === void 0 ? void 0 : (_values_ = values[0]) === null || _values_ === void 0 ? void 0 : _values_.id
                    }
                ]
            }
        }, {
            onSuccess: ()=>{
                onSuccess({
                    customFieldWithValues,
                    values
                });
            }
        });
    }, [
        batchUpdateFormAssets,
        clips,
        customField.id,
        customFieldWithValues,
        onSuccess,
        store
    ]);
    return /*#__PURE__*/ _jsx(BoardCollectionCustomFieldsSelect, {
        disabled: disabled || isPending,
        clips: clips,
        field: customFieldWithValues,
        onSelectionChange: onSelectionChange
    });
});
ContentCollectionCustomFieldSingleSelect.displayName = "ContentCollectionCustomFieldSingleSelect";
